import { EyeIcon } from "@heroicons/react/solid";
import { useState } from "react";
import toast from "react-hot-toast";
import Button from "../../components/Button/Button";
import {
  TextBody,
  TextSecondary,
} from "../../components/DesignSystem/DesignSystemText";
import QRCodeModal from "../../components/QRCodeModal/QRCodeModal";
import { getFrontendEndpoint } from "../../config/env";
import { BASE_ASSET_URL } from "../../utils/asset";

interface Props {
  uniqId?: string | undefined;
  totalClaimCount?: number | undefined;
  expirationTimestamp?: string | undefined;
}

const AdminSection = ({
  uniqId,
  totalClaimCount,
  expirationTimestamp,
}: Props) => {
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const claimUrl = `${getFrontendEndpoint()}/claim/${uniqId}`;

  return (
    <>
      <QRCodeModal
        open={isQRModalOpen}
        onClose={() => {
          setIsQRModalOpen(false);
        }}
        url={claimUrl}
      />

      <section className="flex flex-col gap-y-4 py-3 px-4 rounded bg-[#F4F4F4]">
        <div className="flex justify-between">
          <div className="!overflow-hidden">
            <TextBody className="!font-bold !text-[14rem] mb-1">
              Claim Link
            </TextBody>
            <TextSecondary className="overflow-x-auto mr-4">
              <div className="whitespace-nowrap">{claimUrl}</div>
            </TextSecondary>
          </div>

          <div className="flex items-center gap-x-3 justify-center">
            <Button
              className="h-[30rem] w-[30rem]"
              theme="custom"
              onClick={() => {
                setIsQRModalOpen(true);
              }}
            >
              <img
                className="aspect-square cursor-pointer"
                src={`${BASE_ASSET_URL}/icons/qr-code.svg`}
              />
            </Button>

            <Button
              theme="primary"
              className="!text-[14rem] min-w-[80rem] h-[30rem] !p-0 flex items-center justify-center rounded-[8px]"
              onClick={() => {
                navigator.clipboard.writeText(claimUrl);
                toast.success("Copied link to clipboard");
              }}
            >
              Copy link
            </Button>
          </div>
        </div>

        {totalClaimCount && (
          <div>
            <TextBody className="!font-bold !text-[14rem] mb-1">
              Max Claim
            </TextBody>
            <TextSecondary>{totalClaimCount}</TextSecondary>
          </div>
        )}

        <div>
          <TextBody className="!font-bold !text-[14rem] mb-1">
            Expiration Date
          </TextBody>
          <TextSecondary>
            {expirationTimestamp
              ? new Date(expirationTimestamp).toLocaleString()
              : "Never"}
          </TextSecondary>
        </div>

        <TextSecondary className="!text-[14rem] opacity-50 flex items-center gap-x-1">
          <EyeIcon height={12} width={12} /> <span>Only you can see this</span>
        </TextSecondary>
      </section>
    </>
  );
};

export default AdminSection;
